/**
 * Currency code to flag emoji mapping.
 * Uses regional indicator symbols to create flag emojis.
 * Maps currency to its primary country's flag.
 */
const CURRENCY_FLAGS: Record<string, string> = {
    PLN: '🇵🇱', // Poland
    EUR: '🇪🇺', // European Union
    USD: '🇺🇸', // United States
    GBP: '🇬🇧', // United Kingdom
    CHF: '🇨🇭', // Switzerland
    JPY: '🇯🇵', // Japan
    CNY: '🇨🇳', // China
    AUD: '🇦🇺', // Australia
    CAD: '🇨🇦', // Canada
    SEK: '🇸🇪', // Sweden
    NOK: '🇳🇴', // Norway
    DKK: '🇩🇰', // Denmark
    CZK: '🇨🇿', // Czech Republic
    HUF: '🇭🇺', // Hungary
    RON: '🇷🇴', // Romania
    BGN: '🇧🇬', // Bulgaria
    HRK: '🇭🇷', // Croatia
    RUB: '🇷🇺', // Russia
    UAH: '🇺🇦', // Ukraine
    TRY: '🇹🇷', // Turkey
    INR: '🇮🇳', // India
    BRL: '🇧🇷', // Brazil
    MXN: '🇲🇽', // Mexico
    ZAR: '🇿🇦', // South Africa
    SGD: '🇸🇬', // Singapore
    HKD: '🇭🇰', // Hong Kong
    NZD: '🇳🇿', // New Zealand
    KRW: '🇰🇷', // South Korea
    THB: '🇹🇭', // Thailand
    MYR: '🇲🇾', // Malaysia
    IDR: '🇮🇩', // Indonesia
    PHP: '🇵🇭', // Philippines
    VND: '🇻🇳', // Vietnam
    ILS: '🇮🇱', // Israel
    AED: '🇦🇪', // UAE
    SAR: '🇸🇦', // Saudi Arabia
}

/**
 * Get flag emoji for a currency code.
 * Returns a generic money bag emoji if currency is not mapped.
 */
export function getCurrencyFlag(code: string): string {
    return CURRENCY_FLAGS[code] ?? '💱'
}
